import { useTranslation } from '@/hooks/support/translate';
import { Maybe } from '@/utils/common';
import { TextDetailRow } from '../atom/TextDetailRow';
import { TextInfo } from '../atom/TextInfo';

export type InfoItemProps = {
    title: string;
    info?: string;
    value: Maybe<string> | React.ReactNode;
    condition: boolean;
};

export const InfoItem = ({ title, info, value, condition }: InfoItemProps) => {
    const { t } = useTranslation();
    return (
        <div>
            {condition ? (
                info ? (
                    <TextDetailRow size="small" caption={<TextInfo info={info}>{title}</TextInfo>} value={value} />
                ) : (
                    <TextDetailRow size="small" caption={title} value={value} />
                )
            ) : null}
        </div>
    );
};
